module.exports = __webpack_public_path__ + "static/img/11.1bbc206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/11.png
// module id = D7hB
// module chunks = 0